import React, { useMemo, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export type ReportHelpSection = {
  title?: string;
  items: string[];
};

type ReportHelpButtonProps = {
  title: string;
  intro?: string;
  sections: ReportHelpSection[];
  buttonLabel?: string;
  closeLabel?: string;
};

export default function ReportHelpButton({
  title,
  intro,
  sections,
  buttonLabel = 'Ayuda',
  closeLabel = 'Cerrar',
}: ReportHelpButtonProps) {
  const [open, setOpen] = useState(false);

  const safeSections = useMemo(
    () => sections.filter((s) => Array.isArray(s.items) && s.items.length > 0),
    [sections],
  );

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<HelpOutlineIcon fontSize="small" />}
        onClick={() => setOpen(true)}
      >
        {buttonLabel}
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            {intro && (
              <Typography variant="body2" color="text.secondary">
                {intro}
              </Typography>
            )}

            {safeSections.map((section, idx) => (
              <Stack key={`${section.title ?? 'section'}-${idx}`} spacing={1}>
                {section.title && <Typography variant="subtitle1">{section.title}</Typography>}
                <List dense disablePadding>
                  {section.items.map((item, j) => (
                    <ListItem key={`item-${idx}-${j}`} disableGutters sx={{ py: 0.25 }}>
                      <ListItemText primary={`• ${item}`} />
                    </ListItem>
                  ))}
                </List>
              </Stack>
            ))}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>{closeLabel}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
